import { useDropzone } from 'react-dropzone';
import React, { CSSProperties } from 'react';
import classNames from 'classnames';
import FontAwesomeIcon from '../Icon';
import { convertType } from './filetypehandler';
import './File.scss';

// Todo: Properly migrate all of these types from Vanilla JS to TypeScript.
interface FileProps {
  label?: any;
  files: any[];
  onSelect: any;
  image?: any;
  errors?: any;
  type?: any;
  description?: any;
  multiSelect?: any;
  required?: any;
  documentType?: any;
  documentValidation?: any;
  smallIcon?: any;
  imageType?: any;
  disabled?: boolean; // Added disabled prop
}

const File = ({
  label,
  files,
  onSelect,
  image,
  errors,
  type,
  description,
  multiSelect,
  required,
  documentType,
  documentValidation,
  smallIcon,
  imageType,
  disabled = false, // Default to false (not disabled)
}: FileProps) => {
  // Fix: Use CSSProperties type for style objects
  const thumb: CSSProperties = {
    display: 'inline-flex',
    borderRadius: 2,
    border: '1px solid #eaeaea',
    marginBottom: 8,
    marginRight: 8,
    padding: 4,
    boxSizing: 'border-box' as 'border-box', // Type assertion for specific BoxSizing type
  };

  const thumbInner: CSSProperties = {
    display: 'flex',
    minWidth: 0,
    overflow: 'hidden',
  };

  const img: CSSProperties = {
    display: 'block',
    width: '100%',
    height: '100%',
  };

  let types;
  if (documentType) {
    if (documentType === 'Warranty' || documentType === 'Owners Manual') {
      types = ['word', 'pdf'];
    } else if (documentType === 'Image') {
      types = ['image'];
    } else if (documentType === 'Invoice') {
      types = ['pdf'];
    } else if (documentType === 'Spreadsheet') {
      types = ['spreadsheet', 'presentation'];
    } else if (documentType === 'Contract') {
      types = ['word', 'pdf', 'image'];
    } else if (documentType === 'Video') {
      types = ['video'];
    }
  } else {
    if (type) {
      types = type;
    }
    types = true;
  }

  let acceptType: string = convertType(types);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: acceptType,
    multiple: multiSelect === true ? true : false,
    noClick: documentValidation ? (documentType ? false : true) : false,
    disabled: disabled, // Use the disabled prop here
    onDrop: (acceptedFiles) => {
      // Only process files if not disabled
      if (!disabled) {
        let imageSelected = acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        );
        onSelect(imageSelected);
      }
    },
  });

  const thumbs = files.map((file) => (
    <div style={thumb} key={file.name}>
      <div style={thumbInner}>
        <img src={file.preview} style={img} alt={file.name} />
      </div>
    </div>
  ));

  const displayImage = (
    <>
      {image !== undefined && image !== null && image !== '' ? (
        <div style={thumb} key={image}>
          <div style={thumbInner}>
            <img src={image} style={img} alt={image} />
          </div>
        </div>
      ) : (
        <div>
          <div className="file__icon">
            <FontAwesomeIcon weight="solid" glyph="cloud-upload-alt" />
          </div>
          {imageType === 'image' ? (
            'Upload a Logo'
          ) : documentType === 'Video' ? (
            <h4>Upload a Video</h4>
          ) : (
            <>
              <h4>Add Attachment</h4>
              Click here or Drag and Drop file to Upload
            </>
          )}
        </div>
      )}
    </>
  );

  return (
    <div
      className={classNames('file', {
        'file--active': isDragActive,
        'file--disabled': disabled, // Add disabled class when component is disabled.
      })}
    >
      <label className="file__label">
        {label}
        {required ? <div className="input__required" /> : null}
      </label>
      <div className="file__description">{description}</div>

      <div className="input__errors">
        <div className="input__error">{errors}</div>
      </div>
      <div {...getRootProps({ className: 'dropzone' })}>
        <input
          {...getInputProps()}
          className="file__control"
          disabled={disabled}
        />
        {smallIcon === true ? (
          <div>
            {files.length > 0 ? (
              thumbs
            ) : image != null ? (
              displayImage
            ) : (
              <>
                <div className="file__icon">
                  <FontAwesomeIcon weight="light" glyph="image" />
                </div>
              </>
            )}
          </div>
        ) : (
          <div
            className={classNames('file__dropzone', {
              'file__dropzone--disabled': disabled,
            })}
            style={{ borderRight: '2px solid whitesmoke' } as CSSProperties}
          >
            {files.length > 0 ? (
              thumbs
            ) : image != null ? (
              displayImage
            ) : (
              <>
                <div className="file__icon">
                  <FontAwesomeIcon weight="solid" glyph="cloud-upload-alt" />
                </div>
                {imageType === 'image' ? (
                  'Upload a Logo'
                ) : documentType === 'Video' ? (
                  <h4>
                    {disabled ? 'Video Upload Disabled' : 'Upload a Video'}
                  </h4>
                ) : (
                  <>
                    <h4>{disabled ? 'Upload Disabled' : 'Add Attachment'}</h4>
                    {!disabled && 'Click here or Drag and Drop file to Upload'}
                  </>
                )}
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default File;
